import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ServiceBase} from './base.service';
import {IConfigValues} from '../models/config-values.model';
import {ParsedError} from "./parsed-error";
import {HttpClient} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';


@Injectable()
export class ConfigService extends ServiceBase {

    private completeConfigSource = new BehaviorSubject<IConfigValues>({
        isLoaded: false
    });
    completeConfigInstance = this.completeConfigSource.asObservable();
    // The front end will make a separate api call to load the instrumentation key from the back end. We want to treat that separate api call as if it is a completely separate instance than the one which loads the config.
    private instrumentationKeyConfigSource = new BehaviorSubject<IConfigValues>({
        isLoaded: false
    });
    instrumentationKeyConfigInstance = this.instrumentationKeyConfigSource.asObservable();
    private apiUrl = 'config/';

    constructor(protected http: HttpClient,
                protected toastrService: ToastrService) {
        super(http, null, toastrService);
    }

    loadConfig(callback: (isSuccess: boolean, error?: ParsedError) => void) {
        if (!this.completeConfigSource.value || !this.completeConfigSource.value.isLoaded) {
            const callUrl = this.apiUrl + "Get";
            this.http.get<IConfigValues>(callUrl)
                .subscribe(
                    item => {
                        item.isLoaded = true;
                        this.completeConfigSource.next(item);
                        callback(true, null);
                    },
                    error => {
                        callback(false, this.handleError(error));
                    });
        } else {
            callback(true, null);
        }
    }

    loadInstrumentationKey(callback: (isSuccess: boolean, error?: ParsedError) => void) {
        if (!this.instrumentationKeyConfigSource.value || !this.instrumentationKeyConfigSource.value.isLoaded) {
            const callUrl = this.apiUrl + "GetInstrumentationKey";
            this.http.get<IConfigValues>(callUrl)
                .subscribe(
                    item => {
                        item.isLoaded = true;
                        this.instrumentationKeyConfigSource.next(item);
                        callback(true, null);
                    },
                    error => {
                        callback(false, this.handleError(error));
                    });
        } else {
            callback(true, null);
        }
    }

    save(config: IConfigValues, callback: (isSuccess: boolean, error?: ParsedError) => void) {
        const callUrl = this.apiUrl + 'save';
        this.http.post(callUrl, config)
            .subscribe(
                result => {
                    config.isLoaded = true;
                    this.completeConfigSource.next(config);
                    callback(true, null);
                },
                error => {
                    callback(false, this.handleError(error, config));
                });
    }
}
